import { render, staticRenderFns } from "./TemplateCommonNew.vue?vue&type=template&id=4eb9311e&scoped=true&"
import script from "./TemplateCommonNew.vue?vue&type=script&lang=js&"
export * from "./TemplateCommonNew.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCommonNew.vue?vue&type=style&index=0&id=4eb9311e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb9311e",
  null
  
)

export default component.exports